var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2221",
    d: "M7 10.6111C7 10.3528 7 10.2236 7.0284 10.1177C7.10545 9.83007 7.33007 9.60545 7.61765 9.5284C7.72362 9.5 7.85279 9.5 8.11111 9.5H9.22222C9.48055 9.5 9.60971 9.5 9.71568 9.5284C10.0033 9.60545 10.2279 9.83007 10.3049 10.1177C10.3333 10.2236 10.3333 10.3528 10.3333 10.6111V11.1667C10.3333 12.0871 9.58714 12.8333 8.66667 12.8333C7.74619 12.8333 7 12.0871 7 11.1667V10.6111Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2272",
    d: "M10.25 10.7474H11.2355C12.3057 10.7474 12.8408 10.7474 13.2964 10.6509C14.615 10.3715 15.6908 9.51464 16.1616 8.36867C16.3242 7.97275 16.3906 7.49366 16.5233 6.53548C16.5732 6.17577 16.5981 5.99592 16.5741 5.8488C16.5044 5.42034 16.161 5.06938 15.6984 4.95376C15.5396 4.91406 15.3387 4.91406 14.937 4.91406H2.39635C1.99459 4.91406 1.79371 4.91406 1.63489 4.95376C1.17235 5.06938 0.828974 5.42034 0.759198 5.8488C0.735239 5.99592 0.760155 6.17577 0.809987 6.53548C0.94273 7.49366 1.0091 7.97275 1.17174 8.36867C1.6425 9.51464 2.71831 10.3715 4.03697 10.6509C4.49254 10.7474 5.02765 10.7474 6.09786 10.7474H7.08333",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6734",
    d: "M1.58301 9.08203V10.7487C1.58301 13.8914 1.58301 15.4627 2.50508 16.4391C3.42715 17.4154 4.9112 17.4154 7.8793 17.4154H9.45338C12.4215 17.4154 13.9055 17.4154 14.8276 16.4391C15.7497 15.4627 15.7497 13.8914 15.7497 10.7487V9.08203",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2224",
    d: "M11.5833 4.91536L11.5189 4.62102C11.1981 3.15431 11.0377 2.42095 10.6558 2.00149C10.2738 1.58203 9.76655 1.58203 8.75195 1.58203H8.58138C7.56679 1.58203 7.05949 1.58203 6.67757 2.00149C6.29565 2.42095 6.13523 3.15431 5.81439 4.62102L5.75 4.91536",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.46c4d0144b60ad04b4883ffc7bc5cc6d.svg";
export { ForwardRef as ReactComponent };